import { Button, ButtonLabel } from "@similarweb/ui-components";
import type { IProModalCustomStyles } from "pro-features/components/Modals/src/ProModal";
import styled from "styled-components";
import { setFontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";

export const StyledTitle = styled.h3`
    ${setFontVariant("h5", colorsPalettes.carbon[500])}

    line-height: 24px;
    margin: 0;
`;

export const StyledCloseButton = styled(Button)`
    margin-right: 4px;

    ${ButtonLabel} {
        font-weight: 700;
    }
`;

export const StyledModalFooter = styled.div`
    display: inline-flex;
    width: 100%;
    justify-content: flex-end;
`;

export const modalStyles: IProModalCustomStyles = {
    content: {
        width: 360,
        padding: "20px 16px 16px 20px",
        display: "flex",
        flexDirection: "column",
    },
};
